import { useCallback, useState } from 'react';
import { ContentBlock, OverflowHidden, ShowMoreButton } from './styled';
import { useTracking } from 'react-tracking';
import { Heading, Bones } from '@simplywallst/ui-core';
import { SlideContent } from '../styled';
import { Modal } from '@simplywallst/ui-core';
import sanitize from 'sanitize-html';
import { pathToAction } from 'redux-first-router';
import { useDispatch } from 'react-redux';
import routesGenerator from '@/router/routesGenerator';

interface Props {
  isFetching?: boolean;
  tickerSymbol?: string;
  canonicalUrl?: string;
  innerHTML?: string;
}

const NarrativeRationalSlide = ({
  isFetching = true,
  tickerSymbol = '',
  canonicalUrl = '',
  innerHTML = '',
}: Props) => {
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'NarrativeRationalSlide',
  });
  const [showMore, setShowMore] = useState(false);
  const safeHTML = sanitize(innerHTML);
  const dispatch = useDispatch();
  const viewCompanyReport = useCallback(() => {
    if (canonicalUrl.length === 0) return;
    trackEvent({
      modifier: 'viewCompanyReport',
      action: 'click',
    });
    const action = pathToAction(canonicalUrl, routesGenerator());
    dispatch(action);
  }, [canonicalUrl, trackEvent, dispatch]);
  return (
    <SlideContent
      as="section"
      rowGap="16px"
      templateRows="21px auto 40px"
      data-cy-id="narrative-rational-slide"
    >
      <Heading as="h3" typography="xSmall" color="whiteRGBA" opacity={0.5}>
        Why{tickerSymbol.length > 0 ? ` ${tickerSymbol}` : ''}?
      </Heading>
      {isFetching ? (
        <div>
          <Bones maxWidth="90%" marginTop="x0_5" marginBottom="x2" />
          <Bones maxWidth="85%" marginTop="x0_5" marginBottom="x2" />
          <Bones maxWidth="78%" marginTop="x0_5" marginBottom="x2" />
          <Bones maxWidth="89%" marginTop="x0_5" marginBottom="x2" />
          <Bones maxWidth="92%" marginTop="x0_5" marginBottom="x2" />
          <Bones maxWidth="75%" marginTop="x0_5" marginBottom="x2" />
        </div>
      ) : (
        <OverflowHidden>
          <ContentBlock dangerouslySetInnerHTML={{ __html: safeHTML }} />
        </OverflowHidden>
      )}
      {isFetching === false && (
        <ShowMoreButton
          styleType="loudLarge"
          display="block"
          disabled={isFetching}
          onClick={() => {
            setShowMore(true);
            trackEvent({
              type: 'track',
              subject: `Why ${tickerSymbol}?`,
              modifier: 'Show more',
              action: 'click',
            });
          }}
        >
          Show more
        </ShowMoreButton>
      )}
      {showMore && (
        <Modal
          title={`Why ${tickerSymbol}?`}
          secondaryLabel="Close"
          primaryLabel="See Company Report"
          onSecondaryClick={() => setShowMore(false)}
          onPrimaryClick={() => viewCompanyReport()}
        >
          <ContentBlock dangerouslySetInnerHTML={{ __html: safeHTML }} />
        </Modal>
      )}
    </SlideContent>
  );
};

export default NarrativeRationalSlide;
